export const
  AMBITS = {
    LAND: 'LAND',
    AIR: 'AIR',
    SPACE: 'SPACE',
    WATER: 'WATER',
  },

  AMBIT_ORDER = [
    AMBITS.SPACE,
    AMBITS.AIR,
    AMBITS.LAND,
    AMBITS.WATER
  ],

  AMBIT_ENUM = {
    'NONE': 0,
    'WATER': 1,
    'LAND': 2,
    'AIR': 3,
    'SPACE': 4,
    'LOCAL': 5
  }
;